import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { tokens } from '@hotjar/hotsauce';
import { DetailLabel } from './components/DetailLabel';
import { DetailLabelIcon } from './components/DetailLabelIcon';

export const StyledBox = styled.div<{ hasDivider: boolean }>`
  display: flex;
  flex-direction: row;

  ${(props) =>
    props.hasDivider &&
    css`
      border-top: 1px dashed ${tokens.color.ui_border};
    `}

  &:hover {
    background: ${tokens.color.neutral_100};

    ${DetailLabel} {
      border-bottom-color: ${tokens.color.ui_border_alt};

      &:hover {
        border-bottom-style: solid;
      }
    }

    ${DetailLabelIcon} {
      opacity: 1;
      visibility: visible;
    }
  }
`;

export const DetailsContainer = styled.div`
  flex: 1 1 65%;
  padding: 30px 0 30px 30px;
`;

export const SiteName = styled.span`
  display: block;
  font-size: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 400px;
`;

export const CostContainer = styled.div`
  background: rgba(0, 0, 0, 0.025);
  border-left: 1px solid rgba(0, 0, 0, 0.05);
  padding: 70px 20px 0 20px;
  margin-left: auto;
  flex: 1 1 35%;
`;
